import Tooltip from "../Tooltip";

const SortableTableHeader = ({
  header,
  onClick,
  sortKey,
  sortDirection,
  columnStyle = "px-6 py-3",
}) => {
  const isSortable = header.sortable !== false;

  const renderSortDirectionIcon = (key) => {
    if (key !== sortKey) {
      return "";
    } else {
      if (sortDirection === "desc") return "";
      else return "";
    }
  };

  return (
    <th
      scope="col"
      className={
        (columnStyle || "px-6 py-3") + " relative " + (header.className || "")
      }
      style={header.style}
      onClick={() => isSortable && onClick(header.key)}
    >
      {header.render ? header.render : header.label}
      {header.tooltip && (
        <div className="inline-block align-text-top ml-2">
          <Tooltip message={header.tooltip}>
          </Tooltip>
        </div>
      )}
      {isSortable && (
        <div className="ml-2 inline-block">
          {renderSortDirectionIcon(header.key)}
        </div>
      )}
    </th>
  );
};

export default SortableTableHeader;
